import React from 'react';

class ProfileInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileId: this.props.profileId
        };
    }

    componentDidMount = () => {}

    componentWillReceiveProps = (nextProps) => {
		this.setState({
			profileId: nextProps.profileId
		});
    }

    render() {
		return (
			<div className="page_course_box profile_content_wrapper">
				<div className="title_box">
					<div className="title">
						Professor Nez’s Services
					</div>
					<div className="info">
						<div className="avatar_wrapper no_background">
							<img src="/static/img/appimg/common-noavatar-sm.jpg"/>
						</div>
						<div className="clm_content_wrapper clm_content_left">
							Services provided by&nbsp;
							<p className="major_name">Professor Nez</p>
						</div>
					</div>
				</div>
                <div className="smp-service-pages-top-card__actions">
                    <a href="/services/page/000a80307901578a56/request-proposal/?lipi=urn%3Ali%3Apage%3Ad_flagship3_services_page%3BSetYlFhOTGSrYACYjg4OsQ%3D%3D"
                       id="ember31"
                       className="ember-view artdeco-button artdeco-button--2 artdeco-button--primary mt3 mr2 smp-service-pages-buyer-top-card__request-proposal-cta smp-service-pages-buyer-top-card-primary-cta__trigger-js"
                       data-ntt-old-href="/services/page/000a80307901578a56/request-proposal/">
                            <span dir="ltr">
                                <span aria-hidden="true">
                                    Request proposal
                                </span>
                                <span className="visually-hidden">
                                    Request proposal
                                </span>
                            </span>
                    </a>
                    <div id="ember32"
                         className="artdeco-dropdown artdeco-dropdown--placement-bottom artdeco-dropdown--justification-left ember-view mt3 mr3">
                        <button aria-expanded="false" aria-label="See more options" id="ember33"
                                className="artdeco-dropdown__trigger artdeco-dropdown__trigger--placement-bottom ember-view artdeco-button artdeco-button--2 artdeco-button--secondary artdeco-button--muted smp-service-pages-header-overflow-actions__dropdown-trigger"
                                type="button" tabIndex="0">
                            <span className="artdeco-button__text"> More… </span>
                        </button>
                        <div tabIndex="-1" aria-hidden="true" id="ember34"
                             className="artdeco-dropdown__content artdeco-dropdown--is-dropdown-element artdeco-dropdown__content--has-arrow artdeco-dropdown__content--arrow-left artdeco-dropdown__content--justification-left artdeco-dropdown__content--placement-bottom ember-view smp-service-pages-header-overflow-actions__dropdown-content">
                        </div>
                    </div>
                </div>
			</div>
		)
    }
}

export default ProfileInfo;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_info.js
 **/